<template>
  <div ref="refSwiper" :class="b()" :style="style">
    <slot />
  </div>
</template>

<script src="./notifications-swiper.script.js" />
